import i18n from '@/utils/i18n';
export default {
  inject: ['namespace', '$vroot'],
  props: {
    label: {
      type: String,
      required: false,
    },
    i18n: {
      type: String,
      required: false,
    },
    model: {
      type: String,
      required: true,
    },
    modelid: Number,
  },
  data() {
    // créer des binding vers les model dans MachinDetail à partir du string dans Model
    const model = this.model;

    const path = model.split('.');
    var name = path[path.length - 1];
    var lookup = this.$vroot;
    for (var i in path) {
      lookup = lookup[path[i]];
      if (!lookup) {
        break;
      }
    }

    return {
      inner: lookup, // binding vers le field
      lastPath: name, // this.form.field.label
    };
  },
  computed: {
    labelText() {
      // calcule le label à partir du namespace et du lastPath ou du i18n fourni en props
      if (this.label) {
        return this.label;
      } else if (this.i18n) {
        return i18n.t(this.i18n);
      } else {
        return i18n.t(this.namespace + '.' + this.lastPath);
      }
    },
  },
};
